import type { NichePermissionConfig } from "./types";
import { DEFAULT_INDUSTRY_ID, LEAD_MANAGEMENT_INDUSTRY_SLUG } from "./types";

/**
 * Global niche modules per industry (keys must match API `access_config.global`).
 * Add new industries here; `buildAllNicheGlobalPermissionMap` unions all module keys for `GLOBAL_PERMISSION_MAP`.
 */
export const INDUSTRY_NICHE_GLOBAL_REGISTRY: Record<
  number,
  NichePermissionConfig
> = {
  1: {
    sectionLabel: "University, Course & Scholarship Management",
    modules: [
      { key: "university_management", label: "University" },
      { key: "course_management", label: "Course" },
    ],
  },
  4: {
    sectionLabel: "Service & Variant Management",
    modules: [
      { key: "videoService_management", label: "Service" },
      { key: "videoServiceVarients_management", label: "Service Variant" },
      { key: "videoModels_management", label: "Model" },
      { key: "videoAmbient_management", label: "Ambient" },
    ],
  },
  5: {
    sectionLabel: "Program & Variant Management",
    modules: [
      { key: "academyProgram_management", label: "Program" },
      { key: "academyProgramVariant_management", label: "Program Variant" },
    ],
  },
};

const A = "allow" as const;
const DEFAULT_NICHE_CRUD_MAP: Record<string, string> = {
  create: A,
  edit: A,
  view: A,
  delete: A,
};

/** Union of all niche module keys across industries; same shape as former `NICHE_GLOBAL_PERMISSION_MAP`. */
export function buildAllNicheGlobalPermissionMap(): Record<
  string,
  Record<string, string>
> {
  const out: Record<string, Record<string, string>> = {};
  for (const config of Object.values(INDUSTRY_NICHE_GLOBAL_REGISTRY)) {
    for (const mod of config.modules) {
      out[mod.key] = { ...DEFAULT_NICHE_CRUD_MAP };
    }
  }
  return out;
}

/** Lead Management has no niche module, so its roles carry none. */
const NO_NICHE_MODULES: NichePermissionConfig = { sectionLabel: "", modules: [] };

export function getNichePermissionConfig(
  industryId?: number,
  industrySlug?: string | null
): NichePermissionConfig {
  if (industrySlug === LEAD_MANAGEMENT_INDUSTRY_SLUG) return NO_NICHE_MODULES;
  const id = industryId ?? DEFAULT_INDUSTRY_ID;
  return (
    INDUSTRY_NICHE_GLOBAL_REGISTRY[id] ??
    INDUSTRY_NICHE_GLOBAL_REGISTRY[DEFAULT_INDUSTRY_ID]
  );
}
